/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { useEffect, useState } from 'react';
import { css, StyleSheet } from 'aphrodite';
import type { ReduxProps } from './DrawerInboxContainer';
import { NewThreadModalContainer } from '../../../Inbox/containers/NewThreadModal';
import { NewMessageBtn } from '../../../Inbox/components/NewMessageBtn';
import { InboxContainer } from '../../../Inbox/containers';
import { Text } from '@blend/enterprise-components';
import { BlendBridge } from 'blb-types/blendBridge';

const styles = StyleSheet.create({
  copyWrapper: {
    alignItems: 'center',
    display: 'flex',
  },
  headerWrapper: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '7px 14px 18px',
  },
});

const STYLING_CONFIG = {
  additionalPadding: true,
  columnReplyCounts: true,
  condensedDetails: true,
  hideTags: true,
  highlightSectionHeaders: true,
  singleItemPerRow: true,
};

export namespace DrawerInbox {
  export interface Props {
    tenant: string;
    topic: BlendBridge.API.Topic;
    userId: string;
  }
}

export const DrawerInbox: React.FC<DrawerInbox.Props & ReduxProps> = ({
  userId,
  tenant,
  fetchUserInfo,
  selectedThread,
  topic,
}) => {
  const [isNewThreadModalOpen, setNewThreadModalOpen] = useState<boolean>(false);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    (async () => {
      await fetchUserInfo(userId);
    })();
  }, []);

  return (
    <React.Fragment>
      <NewThreadModalContainer
        handleClose={() => setNewThreadModalOpen(false)}
        isOpen={isNewThreadModalOpen}
        tenant={tenant}
      />
      {!selectedThread && (
        <div className={css(styles.headerWrapper)}>
          <div className={css(styles.copyWrapper)}>
            <Text fontSize="md" weight="bold">
              Fee collaboration messages
            </Text>
          </div>
          <NewMessageBtn handleClick={() => setNewThreadModalOpen(true)} />
        </div>
      )}
      <InboxContainer stylingConfig={{ ...STYLING_CONFIG, topic }} />
    </React.Fragment>
  );
};
